import styled from 'styled-components';

export const HighlightedOfferPanel = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px;
  background: ${props => props.theme.bg.secondary};
  border-radius: 16px;
`;
export const HighlightedOfferColumn = styled.div``;
